document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const qs = (selector, scope = document) => scope.querySelector(selector);
const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' }[character]));

// Move the original controls into a single body-level viewport surface while open.
// No cloned header, filtered ancestor, measured header offset, or vh subtraction.
const mobileMenuQuery = window.matchMedia('(max-width: 820px)');
let menuScrollY = 0;
let menuScrollX = 0;
let mobileMenuOverlay;
let mobileMenuOrigins = [];
const updateMenuViewport = () => {
  if (mobileMenuOverlay && !mobileMenuOverlay.hidden) {
    // Fallback for engines without dvh; modern engines use the CSS dvh declaration.
    mobileMenuOverlay.style.setProperty('--menu-viewport-height', `${window.innerHeight}px`);
  }
};
const setMobileMenu = (open, restoreFocus = false) => {
  const menu = qs('[data-mobile-menu]');
  const button = qs('[data-menu-toggle]');
  const header = qs('[data-site-header]');
  if (!menu || !button || !header || (open && !mobileMenuQuery.matches)) return;
  if (open === document.body.classList.contains('menu-open')) return;
  if (open) {
    menuScrollY = window.scrollY;
    menuScrollX = window.scrollX;
    if (!mobileMenuOverlay) {
      mobileMenuOverlay = document.createElement('div');
      mobileMenuOverlay.className = 'mobile-menu-overlay';
      mobileMenuOverlay.hidden = true;
      document.body.appendChild(mobileMenuOverlay);
      let touchY = 0;
      mobileMenuOverlay.addEventListener('touchstart', (event) => {
        touchY = event.touches[0].clientY;
      }, { passive: true });
      mobileMenuOverlay.addEventListener('touchmove', (event) => {
        const delta = event.touches[0].clientY - touchY;
        touchY = event.touches[0].clientY;
        const atStart = menu.scrollTop <= 0;
        const atEnd = menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 1;
        if (!menu.contains(event.target) || (delta > 0 && atStart) || (delta < 0 && atEnd)) {
          if (event.cancelable) event.preventDefault();
        }
      }, { passive: false });
    }
    const announcement = header.parentElement.querySelector('.announcement');
    mobileMenuOrigins = [announcement, header, menu].filter(Boolean).map((node) => {
      const marker = document.createComment('mobile menu return point');
      node.before(marker);
      return { node, marker };
    });
    mobileMenuOrigins.forEach(({ node }) => mobileMenuOverlay.appendChild(node));
    document.body.style.setProperty('--menu-scroll-top', `${-menuScrollY}px`);
    document.body.classList.add('menu-open');
    document.documentElement.classList.add('menu-open');
    menu.hidden = false;
    mobileMenuOverlay.hidden = false;
    updateMenuViewport();
    button.focus({ preventScroll: true });
  } else {
    menu.hidden = true;
    mobileMenuOverlay.hidden = true;
    mobileMenuOrigins.forEach(({ node, marker }) => marker.replaceWith(node));
    mobileMenuOrigins = [];
    document.body.classList.remove('menu-open');
    document.documentElement.classList.remove('menu-open');
    document.body.style.removeProperty('--menu-scroll-top');
    window.scrollTo({ left: menuScrollX, top: menuScrollY, behavior: 'instant' });
    if (restoreFocus) button.focus({ preventScroll: true });
  }
  button.setAttribute('aria-expanded', String(open));
  button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
};
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-menu-toggle]');
  if (button) setMobileMenu(button.getAttribute('aria-expanded') !== 'true');
  if (event.target.closest('[data-mobile-menu] a, [data-cart-open], .wordmark')) setMobileMenu(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMobileMenu(false, true);
});
window.addEventListener('resize', () => {
  if (!mobileMenuQuery.matches) setMobileMenu(false);
  else updateMenuViewport();
});
window.visualViewport?.addEventListener('resize', updateMenuViewport);
window.addEventListener('pagehide', () => setMobileMenu(false));

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  qsa('[data-reveal]').forEach((element) => revealObserver.observe(element));
} else {
  qsa('[data-reveal]').forEach((element) => element.classList.add('is-visible'));
}

qsa('[data-home-carousel]').forEach((carousel) => {
  const slides = qsa('[data-carousel-slide]', carousel);
  const viewport = qs('.home-hero__media', carousel);
  const status = qs('[data-carousel-status]', carousel);
  let current = 0;
  let touchStartX = 0;
  let suppressSlideClick = false;

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.tabIndex = active ? 0 : -1;
    });

    const activeSlide = slides[current];
    if (status) status.textContent = `Showing ${activeSlide.dataset.carouselName} image ${current + 1} of ${slides.length}`;
  };

  qs('[data-carousel-previous]', carousel)?.addEventListener('click', () => show(current - 1));
  qs('[data-carousel-next]', carousel)?.addEventListener('click', () => show(current + 1));
  viewport?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  viewport?.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0].clientX;
    suppressSlideClick = false;
  }, { passive: true });
  viewport?.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 48) {
      suppressSlideClick = true;
      show(current + (distance < 0 ? 1 : -1));
      window.setTimeout(() => { suppressSlideClick = false; }, 450);
    }
  }, { passive: true });
  viewport?.addEventListener('click', (event) => {
    if (suppressSlideClick && event.target.closest('[data-carousel-slide]')) {
      event.preventDefault();
      suppressSlideClick = false;
    }
  }, true);
});

qsa('[data-product-gallery]').forEach((gallery) => {
  const slides = qsa('[data-gallery-slide]', gallery);
  const thumbs = qsa('[data-gallery-thumb]', gallery);
  const currentLabel = qs('[data-gallery-current]', gallery);
  let current = 0;
  let touchStartX = 0;
  const useNativeScroll = window.matchMedia('(max-width: 820px)').matches;

  const show = (index, focusThumb = false) => {
    current = (index + slides.length) % slides.length;
    if (useNativeScroll) {
      slides[current]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      return;
    }
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === current;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', String(active));
      thumb.tabIndex = active ? 0 : -1;
    });
    if (currentLabel) currentLabel.textContent = String(current + 1);
    if (focusThumb && thumbs[current]) thumbs[current].focus();
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryIndex)));
    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1), true);
      }
    });
  });
  qs('[data-gallery-previous]', gallery)?.addEventListener('click', () => show(current - 1));
  qs('[data-gallery-next]', gallery)?.addEventListener('click', () => show(current + 1));
  const viewport = qs('.product-gallery__viewport', gallery);
  viewport?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  viewport?.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 48) show(current + (distance < 0 ? 1 : -1));
  }, { passive: true });
});

const drawer = qs('[data-cart-drawer]');
const drawerPanel = qs('[data-cart-panel]');
const drawerBody = qs('[data-cart-drawer-body]');
const drawerFooter = qs('[data-cart-drawer-footer]');
const toast = qs('[data-toast]');
let lastFocusedElement = null;

const formatMoney = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
  style: 'currency',
  currency
}).format(cents / 100);

const updateCartCount = (count) => {
  qsa('[data-cart-count]').forEach((element) => { element.textContent = count; });
  qsa('[data-cart-open]').forEach((element) => element.setAttribute('aria-label', `Cart with ${count} ${count === 1 ? 'item' : 'items'}`));
  const drawerCount = qs('[data-drawer-count]');
  if (drawerCount) drawerCount.textContent = `(${count})`;
};

const showToast = (message) => {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(showToast.timeout);
  showToast.timeout = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
};

const renderCart = (cart) => {
  updateCartCount(cart.item_count);
  if (!drawerBody || !drawerFooter) return;

  if (!cart.item_count) {
    drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is ready for something with character.</p><a class="button button--secondary" href="/collections/all">Shop AirPods cases</a></div>';
    drawerFooter.hidden = true;
    return;
  }

  drawerBody.innerHTML = cart.items.map((item, index) => {
    const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=240` : '';
    const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" width="120" height="120" alt="${escapeHtml(item.product_title)}">` : '<span class="cart-drawer__image-placeholder"></span>';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : '';
    return `<article class="cart-drawer__item">
      <a class="cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
      <div class="cart-drawer__item-copy">
        <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
        ${variant}
        <div class="quantity-control" aria-label="Quantity for ${escapeHtml(item.product_title)}">
          <button type="button" aria-label="Decrease quantity" data-cart-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
          <span aria-live="polite">${item.quantity}</span>
          <button type="button" aria-label="Increase quantity" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}">+</button>
        </div>
      </div>
      <div class="cart-drawer__item-end">
        <strong>${formatMoney(item.final_line_price, cart.currency)}</strong>
        <button type="button" data-cart-change data-line="${index + 1}" data-quantity="0">Remove</button>
      </div>
    </article>`;
  }).join('');

  const subtotal = qs('[data-cart-subtotal]');
  if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
  drawerFooter.hidden = false;
};

const getCart = async () => {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to load your cart.');
  const cart = await response.json();
  renderCart(cart);
  return cart;
};

const openCart = async (trigger) => {
  if (!drawer || !drawerPanel) return;
  lastFocusedElement = trigger || document.activeElement;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-open');
  drawerPanel.focus();
  try {
    await getCart();
  } catch (error) {
    if (drawerBody) drawerBody.innerHTML = `<div class="cart-drawer__empty"><p>${escapeHtml(error.message)}</p><a class="button button--secondary" href="/cart">Open cart page</a></div>`;
  }
};

const closeCart = () => {
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-open');
  if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
};

document.addEventListener('click', async (event) => {
  const openTrigger = event.target.closest('[data-cart-open]');
  if (openTrigger) {
    event.preventDefault();
    openCart(openTrigger);
    return;
  }
  if (event.target.closest('[data-cart-close]')) {
    closeCart();
    return;
  }
  const changeButton = event.target.closest('[data-cart-change]');
  if (changeButton) {
    changeButton.disabled = true;
    drawerBody?.classList.add('is-updating');
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(changeButton.dataset.line), quantity: Number(changeButton.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Unable to update your cart.');
      renderCart(await response.json());
    } catch (error) {
      showToast(error.message);
      changeButton.disabled = false;
    } finally {
      drawerBody?.classList.remove('is-updating');
    }
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') closeCart();
  if (event.key === 'Tab' && drawer?.getAttribute('aria-hidden') === 'false' && drawerPanel) {
    const focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', drawerPanel);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
});

qsa('[data-product-form]').forEach((form) => {
  const button = qs('[data-add-to-cart]', form);
  const label = qs('[data-add-label]', form);
  const status = qs('[data-product-status]', form);
  const select = qs('[data-variant-select]', form);
  const section = form.closest('[data-product-section]');

  const updateVariant = () => {
    if (!select) {
      const variantInput = qs('input[name="id"]', form);
      const available = variantInput?.dataset.available !== 'false';
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? 'Add to bag' : 'Sold out';
      return;
    }
    const option = select.selectedOptions[0];
    const selected = Boolean(option?.value && option.dataset.available !== undefined);
    const available = selected && option.dataset.available === 'true';
    const price = option?.dataset.price;
    if (price) qsa('[data-product-price], [data-add-price], [data-mobile-price]', section).forEach((element) => { element.textContent = price; });
    if (button) button.disabled = !available;
    if (label) label.textContent = selected ? (available ? 'Add to bag' : 'Sold out') : 'Choose your AirPods model';
    const mobileButton = qs('[data-mobile-add]', section);
    if (mobileButton) mobileButton.disabled = !available;
    const stockStatus = qs('[data-stock-status]', section);
    if (stockStatus && selected) stockStatus.innerHTML = available ? '<span></span>In stock' : 'Sold out';
  };
  select?.addEventListener('change', updateVariant);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (select && section?.dataset.variantTouched !== 'true') {
      if (status) status.textContent = 'Choose your AirPods model to continue.';
      qs('.variant-picker', section)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      qs('[data-variant-button]:not([disabled])', section)?.focus();
      return;
    }
    const original = label?.textContent || 'Add to cart';
    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';
    if (status) status.textContent = '';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      if (label) label.textContent = 'Added';
      if (status) status.textContent = `${result.product_title || 'Item'} added to your cart.`;
      await openCart(button);
    } catch (error) {
      if (label) label.textContent = 'Try again';
      if (status) status.textContent = error.message;
    } finally {
      window.setTimeout(() => {
        updateVariant();
      }, 900);
    }
  });

  const buyBar = qs('[data-mobile-buy-bar]', section);
  if (buyBar && 'IntersectionObserver' in window) {
    const formObserver = new IntersectionObserver(([entry]) => {
      const passedForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      buyBar.classList.toggle('is-visible', passedForm);
      buyBar.setAttribute('aria-hidden', String(!passedForm));
    }, { threshold: 0 });
    formObserver.observe(form);
  }
});

/* Accessible button variants, mobile buy state, and lightweight help UI. */
qsa('[data-product-section]').forEach((section) => {
  const form = qs('[data-product-form]', section);
  const select = qs('[data-variant-select]', section);
  const buttons = qsa('[data-variant-button]', section);
  const mobileButton = qs('[data-mobile-add]', section);
  const mobileTitle = qs('[data-mobile-title]', section);
  const mobileVariant = qs('[data-mobile-variant]', section);
  const variantField = qs('.variant-picker', section);
  const syncButtonState = () => {
    if (!select) return;
    const option = select.selectedOptions[0];
    const selected = Boolean(option?.value && option.dataset.available !== undefined);
    const available = selected && option.dataset.available === 'true';
    buttons.forEach((button) => {
      const selected = button.dataset.variantId === select.value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    const touched = section.dataset.variantTouched === 'true';
    if (mobileTitle) mobileTitle.textContent = touched ? (section.querySelector('.product-title')?.textContent?.trim() || 'Your selection') : 'Choose your AirPods model';
    if (mobileVariant) mobileVariant.textContent = touched ? (option?.textContent?.trim() || '') : '';
    if (mobileButton) mobileButton.textContent = touched ? (available ? `Add to bag — ${option?.dataset.price || ''}` : 'Sold out') : 'Choose model ↑';
    if (selected) {
      const selectedUrl = new URL(window.location.href);
      selectedUrl.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', selectedUrl);
    }
  };
  buttons.forEach((button) => button.addEventListener('click', () => {
    if (!select || button.disabled) return;
    section.dataset.variantTouched = 'true';
    select.value = button.dataset.variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    syncButtonState();
  }));
  select?.addEventListener('change', (event) => { if (event.isTrusted) section.dataset.variantTouched = 'true'; syncButtonState(); });
  syncButtonState();
  mobileButton?.addEventListener('click', () => {
    if (!select) return form?.requestSubmit();
    if (section.dataset.variantTouched !== 'true') {
      variantField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      buttons.find((button) => !button.disabled)?.focus();
      return;
    }
    form?.requestSubmit();
  });
});

qsa('[data-product-gallery]').forEach((gallery) => {
  const viewport = qs('.product-gallery__viewport', gallery);
  const slides = qsa('[data-gallery-slide]', gallery);
  const thumbs = qsa('[data-gallery-thumb]', gallery);
  const count = qs('[data-gallery-current]', gallery);
  if (!viewport || !slides.length) return;
  const setActive = (index) => {
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
    thumbs.forEach((thumb, thumbIndex) => { thumb.classList.toggle('is-active', thumbIndex === index); thumb.setAttribute('aria-selected', String(thumbIndex === index)); });
    if (count) count.textContent = String(index + 1);
    qs('[data-swipe-hint]', gallery)?.setAttribute('hidden', '');
  };
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => slides[Number(thumb.dataset.galleryIndex)]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })));
  if ('IntersectionObserver' in window) new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) setActive(slides.indexOf(entry.target)); }), { root: viewport, threshold: .6 }).observe(slides[0]);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) setActive(slides.indexOf(entry.target)); }), { root: viewport, threshold: .6 });
    slides.slice(1).forEach((slide) => observer.observe(slide));
  }
});

const modelDialog = qs('[data-model-help-dialog]');
let modelDialogTrigger;
qsa('[data-model-help-open]').forEach((button) => button.addEventListener('click', () => { modelDialogTrigger = button; modelDialog?.showModal(); }));
qsa('[data-model-help-close]').forEach((button) => button.addEventListener('click', () => modelDialog?.close()));
modelDialog?.addEventListener('close', () => modelDialogTrigger?.focus());
qsa('[data-trust-toggle]').forEach((button) => button.addEventListener('click', () => { const detail = qs('[data-trust-detail]', button.parentElement); const open = button.getAttribute('aria-expanded') === 'true'; button.setAttribute('aria-expanded', String(!open)); if (detail) detail.hidden = open; }));
